import React from 'react';
import Button from '../../Button';
import s from '../import.module.css';

// Back / Cancel / Next, identical on every step but the first. `nextLabel` and
// `nextDisabled` are all that vary, so the layout lives here once.
export default function StepFooter({
  onBack, onCancel, onNext, nextLabel = 'Next', nextDisabled = false, busy = false, bare = false,
}) {
  return (
    <div className={`${s.imFoot}${bare ? ` ${s.footNoBorder}` : ''}`}>
      {onBack ? <button className={s.imLink} onClick={onBack}>‹ Back</button> : null}
      <span className={s.spacer} />
      <Button variant="secondary" onClick={onCancel}>Cancel</Button>
      <Button onClick={onNext} loading={busy} disabled={nextDisabled}>{nextLabel}</Button>
    </div>
  );
}
